import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';

import { hiringManagerLinkedInEndpoints } from './constants';
import { hiringManagerLinkedInQueryKeys } from './queryKeys';
import type { HiringManagerLinkedInAccountApi } from './types';

export const useHiringManagerLinkedInAccountQuery = (
  tenantId: string | undefined,
) => {
  return useQuery({
    queryKey: hiringManagerLinkedInQueryKeys.account(tenantId),
    queryFn: tenantId
      ? async (): Promise<HiringManagerLinkedInAccountApi> => {
          const { data } = await fetchClient.GET(
            hiringManagerLinkedInEndpoints.account,
            { params: { query: { tenantId } } },
          );
          return data ?? null;
        }
      : skipToken,
  });
};
